export const ACCOUNT = 'account/ACCOUNT';
export const FETCH_ACCOUNT = 'account/FETCH_ACCOUNT_INFO';
export const SIGN_IN = 'account/SIGN_IN';
export const UPDATA_FORCE = 'account/UPDATA_FORCE';
